import api from "@/config/api";

const path = "private/formular/employee/checkin"

export default {
  getById: (id) => {
    return api.get(`${path}/${id}`, { withCredentials: true })
  }
}
